import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import { ISocketNotificationEvent } from '../../services/websockets/types';
import { EAffinyEventOrigin } from '../api/core/affiny.eventorigins';
import { ActionsUnion, createAction } from '../helpers';
import { IPaginationMetadata } from '../helpers/pagination';
import { IMessagesSuccessPayload } from '../threads/actions';
import { IMessage } from './types';

export enum EMessagesActionType {
  DELETE = 'MESSAGE/DELETE',
  GET_MORE = 'MESSAGES/GET_MORE',
  GET_MORE_SUCCESS = 'MESSAGES/GET_MORE_SUCCESS',
  NEW_MESSAGE = 'MESSAGE/NEW',
  NEW_MESSAGE_FROM_WEBSOCKET = 'MESSAGE/WEBSOCKET/NEW',
  POST_DRY_RUN = 'MESSAGE/POST_DRY_RUN',
  POST_MESSAGE = 'MESSAGE/POST',
  POST_MESSAGE_SUCCESS = 'MESSAGE/POST_SUCCESS',
  SET_AS_READ = 'MESSAGE/SET_AS_READ',
}

export const messagesActions = {
  newMessageFromWebsocket: (rawMessage: ISocketNotificationEvent) =>
    createAction(EMessagesActionType.NEW_MESSAGE_FROM_WEBSOCKET, rawMessage),
  newMessage: (message: IMessage) =>
    createAction(EMessagesActionType.NEW_MESSAGE, message),
  postMessage: (payload: {
    receiverAboId: string;
    content: string;
    eventOrigin: EAffinyEventOrigin;
    unsentId?: string;
    threadId?: string;
  }) => createAction(EMessagesActionType.POST_MESSAGE, payload),
  postMessageSuccess: (payload: IMessage) =>
    createAction(EMessagesActionType.POST_MESSAGE_SUCCESS, payload),
  setMessagesAsRead: (ids: string[]) =>
    createAction(EMessagesActionType.SET_AS_READ, {
      ...keyBy(isReadByIds(ids), 'id'),
    }),
  deleteMessage: (messageId: string, threadId: string) =>
    createAction(EMessagesActionType.DELETE, {
      messageId,
      threadId,
    }),
  getMoreMessages: (accountId: string) =>
    createAction(EMessagesActionType.GET_MORE, { accountId }),
  getMoreMessagesSuccess: (payload: {
    entities: IMessagesSuccessPayload;
    threadId: string;
    meta: IPaginationMetadata;
  }) => createAction(EMessagesActionType.GET_MORE_SUCCESS, payload),
  postDryRun: (payload: { threadId: string }) =>
    createAction(EMessagesActionType.POST_DRY_RUN, payload),
};

export type TMessagesActions = ActionsUnion<typeof messagesActions>;

const isReadByIds = (ids: string[]) =>
  map(ids, id => ({
    id,
    attributes: {
      readByMe: true,
    },
  }));
